/**
 * "화면을 열면서 <b>그 화면의 사용 안내까지</b> 편다" 를 주소 한 칸으로 나르는 약속
 * (2026-08-14 · DOC-20 §1.18).
 *
 * <h2>왜 주소에 싣는가</h2>
 * 안내를 여는 스위치는 {@link AppLayout} 이 쥐고 있다(헤더 · 사이드바 · 본문을 함께 가리키므로
 * 그 셋의 공통 부모가 거기뿐이다). 그런데 안내를 <b>열자고 말하는 쪽</b>은 대화 화면이고, 그 사이에
 * 라우팅이 한 번 낀다. 전역 상태를 새로 파는 대신 주소에 싣는 이유는 셋이다.
 *
 * <ul>
 *   <li>이동과 요청이 <b>한 번에</b> 일어난다 — 옮긴 뒤 따로 신호를 보내면 그 사이에 화면이
 *       다시 그려지고, 늦게 도착한 신호는 엉뚱한 화면의 안내를 연다</li>
 *   <li>뒤로 가기를 눌렀을 때 안내가 다시 뜨지 않는다 — 연 직후 이 칸을 지우기 때문이다</li>
 *   <li>대화 밖에서도 쓸 수 있다. 알림 메일이나 다른 화면의 "사용법" 버튼도 같은 주소를 쓴다</li>
 * </ul>
 *
 * <p>값은 보지 않는다 — <b>칸이 있으면 연다.</b> `guide=1` 과 `guide=true` 가 다르게 동작하면
 * 링크를 손으로 적는 자리에서 반드시 어긋난다.
 */

export const GUIDE_PARAM = 'guide';

/** 이 경로로 옮긴 뒤 화면 안내를 펴라. 이미 물음표가 붙은 경로도 받는다. */
export function withGuide(href: string): string {
  return href.includes('?') ? `${href}&${GUIDE_PARAM}=1` : `${href}?${GUIDE_PARAM}=1`;
}
